import {
  HEX,
  SCALING,
  Targeting
} from "../../../src";
const minor_heal = {
  slug: "minor_heal",
  name: "Minor Heal",
  abilityIcon: "minor_heal",
  description: "Heals a target for a small amount of health",
  costs: [{ stat: "mana", value: 5 }],
  targeting: Targeting.SingleAlly,
  cooldown: 0,
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "gain",
              scalingFactors: SCALING.RADIANT_HEALING
            }
          ]
        }
      }
    ]
  },
  tags: ["spell", "ranged", "heal"]
};
export {
  minor_heal
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vbGliL2FiaWxpdGllcy9wYWxhZGluL21pbm9yLWhlYWwudHMiXSwKICAic291cmNlc0NvbnRlbnQiOiBbImltcG9ydCB7XG4gIEFjdGlvbkRlZmluaXRpb24sXG4gIEhFWCxcbiAgU0NBTElORyxcbiAgVGFyZ2V0aW5nLFxufSBmcm9tICcuLi8uLi8uLi9zcmMnO1xuXG5leHBvcnQgY29uc3QgbWlub3JfaGVhbDogQWN0aW9uRGVmaW5pdGlvbiA9IHtcbiAgc2x1ZzogJ21pbm9yX2hlYWwnLFxuICBuYW1lOiAnTWlub3IgSGVhbCcsXG4gIGFiaWxpdHlJY29uOiAnbWlub3JfaGVhbCcsXG4gIGRlc2NyaXB0aW9uOlxuICAgICdIZWFscyBhIHRhcmdldCBmb3IgYSBzbWFsbCBhbW91bnQgb2YgaGVhbHRoJyxcbiAgY29zdHM6IFt7IHN0YXQ6ICdtYW5hJywgdmFsdWU6IDUgfV0sXG4gIHRhcmdldGluZzogVGFyZ2V0aW5nLlNpbmdsZUFsbHksXG4gIGNvb2xkb3duOiAwLFxuICBpbXBhY3RTY2hlZHVsZToge1xuICAgIFswXTogW1xuICAgICAge1xuICAgICAgICBoZXhlczogSEVYLkRPVCxcbiAgICAgICAgZWZmZWN0OiB7XG4gICAgICAgICAgc3RhdENoYW5nZXM6IFtcbiAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgc3RhdDogJ2hlYWx0aCcsXG4gICAgICAgICAgICAgIGRpcmVjdGlvbjogJ2dhaW4nLFxuICAgICAgICAgICAgICBzY2FsaW5nRmFjdG9yczogU0NBTElORy5SQURJQU5UX0hFQUxJTkcsXG4gICAgICAgICAgICB9LFxuICAgICAgICAgIF0sXG4gICAgICAgIH0sXG4gICAgICB9LFxuICAgIF0sXG4gIH0sXG4gIHRhZ3M6IFsnc3BlbGwnLCAncmFuZ2VkJywgJ2hlYWwnXSxcbn07XG4iXSwKICAibWFwcGluZ3MiOiAiQUFBQTtBQUFBLEVBRUU7QUFBQSxFQUNBO0FBQUEsRUFDQTtBQUFBLE9BQ0s7QUFFQSxNQUFNLGFBQStCO0FBQUEsRUFDMUMsTUFBTTtBQUFBLEVBQ04sTUFBTTtBQUFBLEVBQ04sYUFBYTtBQUFBLEVBQ2IsYUFDRTtBQUFBLEVBQ0YsT0FBTyxDQUFDLEVBQUUsTUFBTSxRQUFRLE9BQU8sRUFBRSxDQUFDO0FBQUEsRUFDbEMsV0FBVyxVQUFVO0FBQUEsRUFDckIsVUFBVTtBQUFBLEVBQ1YsZ0JBQWdCO0FBQUEsSUFDZCxDQUFDLENBQUMsR0FBRztBQUFBLE1BQ0g7QUFBQSxRQUNFLE9BQU8sSUFBSTtBQUFBLFFBQ1gsUUFBUTtBQUFBLFVBQ04sYUFBYTtBQUFBLFlBQ1g7QUFBQSxjQUNFLE1BQU07QUFBQSxjQUNOLFdBQVc7QUFBQSxjQUNYLGdCQUFnQixRQUFRO0FBQUEsWUFDMUI7QUFBQSxVQUNGO0FBQUEsUUFDRjtBQUFBLE1BQ0Y7QUFBQSxJQUNGO0FBQUEsRUFDRjtBQUFBLEVBQ0EsTUFBTSxDQUFDLFNBQVMsVUFBVSxNQUFNO0FBQ2xDOyIsCiAgIm5hbWVzIjogW10KfQo=
